import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { DateTimePicker , MuiPickersUtilsProvider,KeyboardDateTimePicker } from '@material-ui/pickers';
import IconButton from "@material-ui/core/IconButton";
import moment from 'moment';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
function ConfirmDatetime(props) {
    const classes = useStyles();
    const [Value,setValue] = React.useState(props.ConfirmDate)
    
    const handleChange=(date)=>{
        //console.log(date)
        let ndate = moment(date)
        setValue(ndate)
        props.onchangeHanelEvent("ConfirmDatetime",ndate)
    }
    return (
        <div>
           <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
               <Fragment>
                   <KeyboardDateTimePicker
                   inputVariant="outlined"
                   label={<IntlMessages id="Input.Confirmation.date"/>}
                   invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                   size="small"
                   fullWidth
                   cancelLabel={<IntlMessages id="Cancel"/>}
                   format="yyyy-MM-dd HH:mm"
                   variant="outlined"
                   ampm={false}
                   animateYearScrolling
                   value={Value}
                   onChange={(date)=>handleChange(date)}
                   KeyboardButtonProps={{
                    "class": "px-0 m-0 btn btn-sm"
                   }}
                    />
                </Fragment>
            </MuiPickersUtilsProvider>  
        </div>
    );
}

export default ConfirmDatetime;